// extracted by mini-css-extract-plugin
export var divider = "_4i-0";
export var dividerText = "_4i-1";